import { useState, useEffect } from 'react'
import { ArrowUp } from 'lucide-react'
import { cn } from '../../lib/utils'

function ScrollToTop() {
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    const toggleVisibility = () => {
      setIsVisible(window.scrollY > 200)
    }

    window.addEventListener('scroll', toggleVisibility)
    return () => window.removeEventListener('scroll', toggleVisibility)
  }, [])

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }

  return (
    <button
      onClick={scrollToTop}
      aria-label="Retour en haut de page"
      className={cn(
        'fixed bottom-8 right-8 z-40',
        'bg-primary hover:bg-primary-600 text-white',
        'w-12 h-12 rounded-full shadow-lg',
        'flex items-center justify-center',
        'transition-all duration-300',
        'focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2',
        'hover:shadow-xl hover:scale-110',
        isVisible
          ? 'opacity-100 translate-y-0'
          : 'opacity-0 translate-y-10 pointer-events-none'
      )}
    >
      <ArrowUp className="h-5 w-5" />
    </button>
  )
}

export default ScrollToTop
